<template>
  <v-card>{{outputMsg}}</v-card>
</template>
<script>
export default {
  data () {
    return {
      outputMsg: ''
    }
  },
  mounted () {
    let page = this.$route.query
    this.outputMsg = 'Something went wrong, try again. If it continues, please contact the admin.'
    if (page) {
      if (page.code) {
        this.outputMsg = 'Code returned successfully! Configurations are going on. Please wait....'

        // do the auth token creations here
        let model = { code: page.code }
        this.$_executeApi('post', 'onedrivesettings/create_my_token', model)
          .then((response) => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
            this.$router.push({ path: '/hse' })
          })
      }
    }
  }
}
</script>
